import { render, staticRenderFns } from "./ChooseComponentTransformOrLink.vue?vue&type=template&id=7fa348dd&"
import script from "./ChooseComponentTransformOrLink.vue?vue&type=script&lang=js&"
export * from "./ChooseComponentTransformOrLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports